<template>
            <!-- Featured Listings -->
        <section class="featured-listing-section common-padding">
            <div class="footer-six-bg footer-nine-bg">
				<img src="@/assets/img/bg/feature-bg.png" alt="">
			</div>
            <div class="container">
                <div class="section-heading section-heading-nine  aos" data-aos="fade-up">
                    <div class="row align-items-center">
                        <div class="col-lg-4 col-md-3"></div>
                        <div class="col-lg-4 col-md-6 aos aos-init aos-animate text-center" data-aos="fade-up">
                            <h2>Featured Listings</h2>
                            <p>The most trendy accommodations available</p>
                        </div>
                        <div class="col-lg-4 col-md-3 text-md-end aos aos-init aos-animate" data-aos="fade-up">
                            <router-link to="categories" class="btn  btn-view">View all Properties</router-link>
                        </div>		
                    </div>	
                  </div>
                  <div class="row aos" data-aos="fade-up" data-aos-delay="200">
                    <div class="col-lg-12">
                        <div class="car-class-carousel">
                            <div class="real-featured-listing owl-carousel owl-theme">
                            <Carousel  :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
						<Slide v-for="item in IndexNineFeatured" :key="item.id">
                                <div class="feature-rent">
                                    <div class="feature-home-img">
                                        <router-link to="listingmap-list"><img :src="require(`@/assets/img/featured/${item.image}`)" class="img-fluid" alt=""></router-link>
                                    </div>
                                    <div class="green-logo">
                                        <img :src="require(`@/assets/img/featured/${item.logo}`)" class="img-fluid" alt="">
                                    </div>
                                    <div class="select-favourite-room">
                                        <div class="favourite-small-user">
                                            <img :src="require(`@/assets/img/profiles/${item.avatar}`)" class="img-fluid" alt="">
                                        </div>
                                        <i class="fa-solid fa-heart"></i>
                                    </div>
                                    <div class="house-location">
                                        <span>{{ item.price }}</span>
                                        <p><i class="feather-map-pin"></i>{{ item.title }}</p>
                                    </div>
                                    <div class="home-img-text">
                                        <div class="star-rated">
                                            <i class="fa-solid fa-star"></i>
                                            <i class="fa-solid fa-star"></i>
                                            <i class="fa-solid fa-star"></i>
                                            <i class="fa-solid fa-star"></i>
                                            <i class="fa-solid fa-star"></i>
                                            <span>{{ item.rating }}</span>
                                        </div>
                                        <h3><router-link to="listingmap-list">{{ item.place }}</router-link></h3>
                                        <div class="top-room-details">
                                            <div class="area">
                                                <span><img src="@/assets/img/icons/area-icon.svg" class="img-fluid" alt="">Area:{{ item.area }}</span>
                                            </div>
                                            <div class="area">
                                                <span><img src="@/assets/img/icons/bed-icon.svg" class="img-fluid" alt="">Beds:{{ item.beds }}</span>
                                            </div>
                                            <div class="area">
                                                <span><img src="@/assets/img/icons/bath-icon.svg" class="img-fluid" alt="">Baths:{{ item.baths }}</span>
                                            </div>
                                        </div>
                                        <div class="house-type">
                                            <span class="room-type"><i class="feather-home"></i>{{ item.title }}Apartments</span>
                                            <span class="double-tick"><i class="fa-solid fa-check-double"></i></span>
                                        </div>
                                    </div>
                                </div>
                                </Slide>
							<template #addons>
								<Pagination />
							</template>
					</Carousel>	
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- /Featured Listings -->
    </template>
    <script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineFeatured from '@/assets/json/indexNineFeatured.json'
    export default {
        data(){
			return{
				IndexNineFeatured: IndexNineFeatured,
				settings: {
				itemsToShow: 1,
				snapAlign: "center"
			},
		
			breakpoints: {
				575: {
					itemsToShow: 2,
					snapAlign: "center"
				},
				// 700px and up
				700: {
					itemsToShow: 3,
					snapAlign: "center"
				},
				// 1024 and up
				1000: {
					itemsToShow: 3,
					snapAlign: "start"
				}
			},
			};
		},
		components: {
			Carousel,
			Slide,
			Pagination,
			Navigation,
		},
		mouted() {},
    };
</script>